module.exports = __webpack_public_path__ + "static/media/Aplus.7c5ca33f.jpg";